import React, { ReactNode, useState } from 'react';
import classNames from 'classnames';
import { FaAngleUp, FaAngleDown } from 'react-icons/fa';

import css from './FAQAccordion.module.scss';

interface IFAQAccordionProps {
  question: string;
  children: ReactNode;
}

const FAQAccordion = ({ question, children }: IFAQAccordionProps) => {
  const [unfolded, setUnfolded] = useState(false);

  const answerStyles = classNames(css.answer, unfolded ? css.show : null);

  return (
    <div className={css.accordionContainer}>
      <div className={css.questionContainer} onClick={() => setUnfolded(!unfolded)}>
        <div className={css.question}>{question}</div>
        <div className={css.dashedLine} />
        <div className={css.control}>{unfolded ? <FaAngleUp /> : <FaAngleDown />}</div>
      </div>
      <div className={answerStyles}>{children}</div>
    </div>
  );
};

export default FAQAccordion;
